<template>
  <div id='question' v-bind:style="{ backgroundColor: color }">
    <div id='questionText'>{{questionText}}<br><a id='next' v-on:click='getQuestion()' v-if='revealed' v-bind:style="{ color: color }">nächste Frage</a></div>
    <button class='answer' v-bind:disabled='revealed' v-on:click.stop='answer(1)' id='yes' v-html='yesText'></button>
    <img v-on:click.stop='pin' v-if='!pinned' class='pin' src='@/assets/pin.svg'>
    <button class='answer' v-bind:disabled='revealed' v-on:click.stop='answer(0)' id='no' v-html='noText'></button>
  </div>
</template>
<script>
export default {
  name: 'Question',
  data(){
    return {
      questionText: null,
      questionId: null,
      color: null,
      yes: null,
      no: null,
      yesPercentage: null,
      noPercentage: null,
      yesText: 'Ja',
      noText: 'Nein',
      revealed: true,
      pinned: false,
      hash: localStorage.getItem('hash')
    }
  },
  computed: {
    percentages(){
      return this.questions.map(q => {
        return {
          yes: ((q.yes * 100 / (q.yes + q.no)) || 0.00).toFixed(2) + '%',
          no: ((q.no * 100 / (q.yes + q.no)) || 0.00).toFixed(2) + '%'
        }
      })
    }
  },
  methods: {
    async pin(){
      this.pinned = true
      let id = this.questionId
      let hash = localStorage.getItem('hash')

      fetch(`${process.env.VUE_APP_API}/pin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id,
          hash
        })
      })
    },
    showVotes(){
      this.yesText =  `${this.yes} × Ja<br>${this.yesPercentage}%`
      this.noText =  `${this.no} × Nein<br>${this.noPercentage}%`
      this.revealed = true
    },
    async getQuestion(questionId = null){
      if(!this.revealed)
        return

      this.yesText = 'Ja'
      this.noText = 'Nein'
      this.revealed = false
      this.pinned = false

      let hash = this.hash

      let response = await fetch(`${process.env.VUE_APP_API}/question`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          questionId,
          hash
        })
      })

      let data = await response.json()
      this.questionText = data.text
      this.questionId = data.rowid
      this.color = data.color
      this.yes = data.yes
      this.no = data.no
      this.next = false
      this.pinned = data.pinned == 'yes' ? true : false

      this.$root.$emit('color', this.color)
      this.$router.replace('/' + this.questionId)
    },
    answer(vote){
      let id = this.questionId
      let hash = this.hash

      fetch(`${process.env.VUE_APP_API}/answer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id,
          vote,
          hash
        })
      })

      if(vote == 0) this.no++
      if(vote == 1) this.yes++

      this.yesPercentage = ((this.yes * 100 / (this.yes + this.no)) || 0.00).toFixed(2)
      this.noPercentage = ((this.no * 100 / (this.yes + this.no)) || 0.00).toFixed(2)

      this.showVotes()
    }
  },
  mounted(){
    this.getQuestion(this.$route.params.questionId)
  }
}
</script>
<style scoped>
#question{
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr 120px;
  grid-template-areas:  
  "question question question"
  "yes pin no";
  height: 100%;
  color: white;
}

.pin{
  grid-area: pin;
  text-align: center;
  width: 40px;
}

.answer{
  text-align: center;
  font-size: 2em;
  color: #2d3436;
  font-weight: bold;
  border: none;
  outline: none;
  background-color: transparent;
}

.answer:active{
  color: #ecf0f1;
}


#yes{
  grid-area: yes;
}

#no{
  grid-area: no;
}

#questionText{
  padding: 20px;
  text-align: center;
  justify-self: center;
  align-self: center;
  grid-area: question;
  font-size: 1.5em;
}

#next{
  margin-top: 30px;
  font-size: 0.9em;
  display: inline-block;
  background-color: white;
  padding: 15px 20px 15px 20px;
  color: black;
  border-radius: 15px;
}
#next:hover, .answer:hover, .pin:hover{
  cursor: pointer;
}
</style>
